"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MaterialChip = exports.MaterialChipUnstyled = void 0;
const material_ui_1 = require("material-ui");
const Cancel_1 = require("material-ui-icons/Cancel");
const Chip_1 = require("material-ui/Chip");
const react_1 = require("react");
const React = require("react");
const decorate = material_ui_1.withStyles(theme => ({
    root: {
        borderRadius: 15,
        height: 30,
        backgroundColor: "#48bac9",
        fontSize: 14,
        color: "#fff",
        textTransform: "uppercase"
    },
    deleteIcon: {
        color: "rgba(0, 0, 0, 0.1)"
    }
}));
class MaterialChipUnstyled extends react_1.Component {
    render() {
        const { classes, onDelete, label } = this.props;
        return (React.createElement(Chip_1.default, { tabIndex: -1, label: label, classes: classes, deleteIcon: React.createElement(Cancel_1.default, { onTouchEnd: onDelete }), onDelete: onDelete }));
    }
}
exports.MaterialChipUnstyled = MaterialChipUnstyled;
exports.MaterialChip = material_ui_1.withTheme()(decorate(MaterialChipUnstyled));



//////////////////
// WEBPACK FOOTER
// ./src/client/components/material/chip/chip.tsx
// module id = 3663
// module chunks = 0